import { ISelectedShiftApplicationsReducer, IApplication } from 'models/Application'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray, deleteFromArray, maybeAddToArray } from 'helpers/helperFunctions'
import { IError } from 'models/Global'
import { FavoriteUpshifter, UnfavoriteUpshifter } from '../Favorite/actions'
import {
  GetSelectedShiftAcceptedApplications,
  GetSelectedShiftAcceptedApplicationsErrors,
  SelectedShiftAcceptedApplicationsFetching,
  AddSelectedShiftAcceptedApplication,
  UpdateSelectedShiftAcceptedApplication,
  SetSelectedShiftCaptain,
  DeleteSelectedShiftAcceptedApplication,
  ResetSelectedShiftAcceptedApplicationsReducer,
} from './actions'

const initialState: ISelectedShiftApplicationsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  error: {} as IError,
  data: [],
}

export const selectedShiftAcceptedApplicationsReducer = (
  state = initialState,
  action: Action
): ISelectedShiftApplicationsReducer => {
  if (isType(action, GetSelectedShiftAcceptedApplications)) {
    const {
      payload: { meta, data },
    } = action
    return {
      ...state,
      meta,
      data,
    }
  }

  if (isType(action, AddSelectedShiftAcceptedApplication)) {
    const { payload } = action
    const { data } = state
    return {
      ...state,
      data: maybeAddToArray(data, payload.data),
    }
  }

  if (isType(action, UpdateSelectedShiftAcceptedApplication)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IApplication>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, SetSelectedShiftCaptain)) {
    const { payload } = action
    const updated = payload.data
    const data = state.data.map((application) => {
      if (application.id === updated.id) {
        return { ...application, ...updated }
      }
      if (application.is_captain && application.id !== updated.id) {
        return {
          ...application,
          is_captain: false,
          pay_bump: null,
          allowed_clock_in_minutes: null,
          allowed_clock_out_minutes: null,
        }
      }
      return application
    })
    return {
      ...state,
      data,
    }
  }

  if (isType(action, DeleteSelectedShiftAcceptedApplication)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IApplication>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  // Favorite and Unfavorite Upshifter
  if (isType(action, FavoriteUpshifter)) {
    const newApplications = state.data.map((application) => {
      if (application.group_application) {
        application.group_application?.applications.data.map((groupApplication) => {
          if (groupApplication.applicant.id === action.payload.data.model_favored.id) {
            const modifiedApplication = groupApplication
            modifiedApplication.applicant.favorite = true
            modifiedApplication.applicant.favorite_id = action.payload.data.id
            return modifiedApplication
          }
          return groupApplication
        })
      } else if (application.applicant.id === action.payload.data.model_favored.id) {
        const modifiedApplication = application
        modifiedApplication.applicant.favorite = true
        modifiedApplication.applicant.favorite_id = action.payload.data.id
        return modifiedApplication
      }
      return application
    })
    return {
      ...state,
      data: newApplications,
    }
  }

  if (isType(action, UnfavoriteUpshifter)) {
    const { payload } = action
    const modifiedApplications = state.data.map((application) => {
      if (application.group_application) {
        application.group_application.applications.data.map((groupApplication) => {
          if (groupApplication.applicant.favorite_id === action.payload) {
            const modifiedApplication = groupApplication
            modifiedApplication.applicant.favorite = false
            modifiedApplication.applicant.favorite_id = null
            return modifiedApplication
          }
          return groupApplication
        })
      } else if (application.applicant.favorite_id === payload) {
        const modifiedApplication = {
          ...application,
          applicant: {
            ...application.applicant,
            favorite: false,
            favorite_id: null,
          },
        }
        return modifiedApplication
      }
      return application
    })
    return {
      ...state,
      data: modifiedApplications,
    }
  }

  if (isType(action, SelectedShiftAcceptedApplicationsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }

  if (isType(action, GetSelectedShiftAcceptedApplicationsErrors)) {
    const { payload } = action
    return {
      ...state,
      error: payload,
    }
  }

  if (isType(action, ResetSelectedShiftAcceptedApplicationsReducer)) {
    return initialState
  }

  return state
}
